var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "software-only") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "software-only",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#979797",
    strokeWidth: 2,
    x: 9,
    y: 16,
    width: 6,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 22,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#979797",
    x: 2,
    y: 22,
    width: 20,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.912442,9.57980517 C10.912442,11.616313 12.606925,13.29724 14.6903569,13.3295656 C15.658037,13.3295656 16.5819212,12.9812842 17.2920399,12.3483296 C18.0042441,11.7174606 18.432818,10.8676122 18.5120677,9.94998452 C18.5433504,9.66843966 18.553778,8.94997889 18.553778,8.66739128 L18.5120677,7.3858408 C18.4317752,6.46821311 17.9979876,5.61523647 17.2920399,4.98749571 C16.5860923,4.35766944 15.658037,4 14.6903569,4 C13.8759623,3.99896043 13.0813802,4.25339356 12.4171429,4.72680603 C12.3879456,4.75078948 12.3796035,4.80501293 12.4108863,4.85193708 L13.2127678,6.13348756 C13.2471788,6.17519791 13.2920174,6.17519791 13.3316423,6.14600066 L13.3316423,6.14808618 C13.713292,5.83838684 14.192961,5.66841716 14.6903569,5.66841716 C15.2013087,5.66841716 15.6914053,5.84568615 16.077226,6.16894136 C16.4630467,6.49219656 16.7070523,6.93015523 16.7758744,7.40773873 C16.824884,7.71639531 16.8311406,8.34622159 16.8311406,8.66634852 L16.7779599,9.9124452 C16.7101806,10.3921142 16.462004,10.8363294 16.0793115,11.1606274 C15.6966191,11.4828399 15.2002659,11.6653226 14.6882714,11.6653226 L14.6872286,11.6653226 C14.1439513,11.6580233 13.6246575,11.439044 13.237794,11.0553088 C12.8561443,10.6820011 12.641336,10.1689639 12.641336,9.63611414 L12.641336,7.74976359 C12.641336,5.71325579 10.946853,4.03232871 8.8634211,4 C7.89678376,4 6.97394228,4.34828461 6.26173807,4.98123916 C5.55057661,5.61210819 5.12096001,6.46404208 5.04171035,7.38166976 C5.01147035,7.66217186 5,8.38271814 5,8.66322024 L5.04171035,9.94685624 C5.12200277,10.8634412 5.5557904,11.7164178 6.26173807,12.3441586 C6.96872849,12.9739848 7.89886928,13.3295656 8.86446386,13.3295656 C9.67885843,13.3295656 10.4734406,13.0761752 11.1376779,12.6027627 C11.1658324,12.5777365 11.1741745,12.5245558 11.1449772,12.4776317 L10.3410102,11.1960812 C10.3065992,11.1543709 10.2617606,11.1543709 10.2221357,11.1814826 L10.2221357,11.1793971 C9.84361431,11.4890964 9.36290254,11.6590661 8.8634211,11.6590661 C8.35246932,11.6590661 7.86237272,11.4817971 7.47655199,11.1595846 C7.09073126,10.8352867 6.84881123,10.397328 6.77790364,9.91974451 C6.72889398,9.61213069 6.72368018,8.98230441 6.72368018,8.66113472 L6.77581812,7.4160808 C6.8446402,6.93432626 7.09177402,6.4911538 7.47446647,6.16894136 C7.85715893,5.84464339 8.35351208,5.66216061 8.86446386,5.66216061 L8.85820731,5.66216061 C9.40148461,5.67050268 9.92077846,5.88843926 10.3055564,6.27113171 C10.6872061,6.64652485 10.9020144,7.15747663 10.9020144,7.6913691 L10.9020144,9.57876241 L10.912442,9.57980517 Z",
    id: "Fill-12",
    fill: "#9B9B9B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareOnly);
export default __webpack_public_path__ + "static/media/software-only.bd0c124f.svg";
export { ForwardRef as ReactComponent };